<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'ミュージアム館内の上映動画のご案内'"
      :sub_title="'〜 Movie 〜'"
      :color="'#fff'"
      :align="'center'"
    ></main-title>
    <div :id="$style.button_area">
      <b-button
        :class="$style.button"
        pill
        variant="info"
        v-for="item in items"
        @click="tabClick(item)"
        :key="item.id"
        >{{ item }}
      </b-button>
    </div>
    <central-movie-visual
      :class="$style.central_movie_area"
      v-if="tab_flag == 0"
    ></central-movie-visual>
    <square-movie-visual
      :class="$style.square_movie_area"
      v-if="tab_flag == 1"
    ></square-movie-visual>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "../../components/atoms/MainTitle";
import CentralMovieVisual from "../organsms/movie/CentralMovieVisual";
import SquareMovieVisual from "../organsms/movie/SquareMovieVisual";
import VueScrollTo from "vue-scrollto";

export default Vue.extend({
  name: "MovieView",

  components: {
    MainTitle,
    CentralMovieVisual,
    SquareMovieVisual,
  },

  data() {
    return {
      items: [" 展示場中央動画コーナー", "HIDEKI'S SQUAREコーナー"],
      tab_flag: 0,
    };
  },
  mounted() {
    const hash = this.$route.hash;
    if (hash && hash.match(/^#.+$/)) {
      VueScrollTo.scrollTo(hash, { offset: -90 });
    }
  },
  methods: {
    tabClick(item) {
      if (item == this.items[0]) {
        this.tab_flag = 0;
      } else if (item == this.items[1]) {
        this.tab_flag = 1;
      }
    },
  },
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background-color: #000011;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    .main_title {
      margin-bottom: 10px;
      align-items: center;
      text-align: center;
    }
    .overview {
      margin: 2em 0;
      text-align: center;
      color: #fff;
    }

    #button_area {
      margin-top: 40px;
      .button {
        width: 130px;
        margin: 0px 10px;
      }
    }
    .article {
      display: grid;
      grid-template-columns: 1fr 70% 1fr;
      justify-items: center;
      align-items: center;

      .my_dream {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 2;
      }
      .world {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 4;
      }
      .matsui_homerun {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 6;
      }
      .jeter {
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #333333;
        margin: 20px 0px;
        padding: 20px 20px;
        grid-column: 2;
        grid-row: 8;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    background-color: #000011;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 100px;

    .overview {
      margin: 2em 0;
      text-align: center;
      color: #fff;
    }

    .main_title {
      text-align: center;
    }

    #button_area {
      /*margin-right: 500px;*/
      margin-top: 40px;

      .button {
        width: 150px;
        margin: 0px 10px;
      }
    }

    .central_movie_area {
      margin-top: 50px;
    }

    .square_movie_area {
      margin-top: 50px;
    }
    .article {
      display: grid;
      grid-template-columns: 1fr 600px 1fr;
      justify-items: center;
      align-items: center;
      .central_movie_are {
        grid-row: 2;
      }
      .my_dream {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 2;
      }
      .world {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 4;
      }
      .matsui_homerun {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 6;
      }
      .jeter {
        background-color: #fff;
        border-radius: 40px;
        border: 1px solid #333333;
        margin: auto 0px;
        padding: 40px 40px;
        grid-column: 2;
        grid-row: 8;
      }

      .sunset {
        grid-column: 1;
        grid-row: 1;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 160px;
        height: 200px;
        align-items: center;
        align-content: center;

        background-image: url("../../assets/img/movie/movie3.jpg");
      }
      .sunset2 {
        grid-column: 3;
        grid-row: 1;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 250px;
        height: 200px;
        align-items: center;
        align-content: center;

        background-image: url("../../assets/img/movie/movie2.jpg");
      }
      .sunset3 {
        grid-column: 3;
        grid-row: 2;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 270px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie7.jpg");
      }
      .sunset4 {
        grid-column: 3;
        grid-row: 4;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 290px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie8.jpg");
      }
      .sunset5 {
        grid-column: 3;
        grid-row: 5;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 170px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie9.jpg");
      }
      .sunset6 {
        grid-column: 3;
        grid-row: 6;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie10.jpg");
      }
      .sunset7 {
        grid-column: 3;
        grid-row: 8;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie11.jpg");
      }
      .sunset8 {
        grid-column: 3;
        grid-row: 9;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie12.jpg");
      }
      .sunset9 {
        grid-column: 1;
        grid-row: 2;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie13.jpg");
      }
      .sunset10 {
        grid-column: 1;
        grid-row: 3;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 270px;
        height: 270px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie14.jpg");
      }
      .sunset11 {
        grid-column: 1;
        grid-row: 4;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 270px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie15.jpg");
      }
      .sunset12 {
        grid-column: 1;
        grid-row: 6;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie16.jpg");
      }
      .sunset13 {
        grid-column: 1;
        grid-row: 7;

        margin: auto 0px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;
        align-items: center;
        align-content: center;
        display: inline-block;
        position: relative;

        background-image: url("../../assets/img/movie/movie17.jpg");
      }

      .cheer {
        grid-column: 3;
        grid-row: 3;

        margin: 0px auto;

        background-repeat: no-repeat;

        background-size: cover;
        width: 300px;
        height: 200px;

        background-image: url("../../assets/img/movie/movie6.jpg");
      }

      .globe {
        grid-column: 1;
        grid-row: 5;
        margin: auto 0px;
        padding: 70px 80px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 200px;
        height: 270px;

        background-image: url("../../assets/img/movie/movie1.jpg");
      }

      .studiam {
        grid-column: 3;
        grid-row: 7;
        margin: auto 0px;
        padding: 70px 80px;
        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 220px;

        background-image: url("../../assets/img/movie/movie4.jpg");
      }
      .studiam2 {
        grid-column: 1;
        grid-row: 8;
        margin: auto 0px;
        padding: 70px 80px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;

        background-image: url("../../assets/img/movie/movie20.jpg");
      }
      .boy {
        grid-column: 1;
        grid-row: 9;
        margin: auto 0px;
        padding: 70px 80px;

        background-repeat: no-repeat;
        background-size: cover;
        width: 300px;
        height: 200px;

        background-image: url("../../assets/img/movie/movie5.jpg");
      }
    }
  }
}
</style>
